import React, { forwardRef, useId } from 'react';

const Youtube = forwardRef(({ href, children, ...attributes }, ref) => {
	const id = useId();

	return (
		<figure
			ref={ref}
			href={href}
			contentEditable={false}
			{...attributes}
		>
			<iframe
				title={id}
				frameBorder="0"
				className="w-full aspect-video rounded-lg"
				src={`https://www.youtube.com/embed/${href}`}
			/>

			{children}
		</figure>
	);
});

export default Youtube;
